// ============================================================================
// Landing nav: centered pill, logo + Stravo, links, Login | Start free
// ============================================================================

import { Link } from "react-router-dom";
import { ChevronDown } from "lucide-react";
import { Button } from "@/components/ui/button";

const NAV_LINKS = [
  { label: "Product", href: "#product", hasDropdown: true },
  { label: "How it works", href: "#how-it-works", hasDropdown: false },
  { label: "Roles", href: "#roles", hasDropdown: false },
  { label: "Pricing", href: "#pricing", hasDropdown: false },
  { label: "Resources", href: "#resources", hasDropdown: true },
];

export default function LandingNav() {
  return (
    <header className="sticky top-2 sm:top-6 z-50 flex justify-center px-3 sm:px-4 py-2">
      <nav
        className="flex w-full max-w-5xl items-center justify-between gap-2 rounded-full border border-border/80 bg-white/70 px-3 py-2 sm:px-5 sm:py-2.5 shadow-sm backdrop-blur-md min-w-0"
        aria-label="Main"
      >
        {/* Left: logo + Stravo */}
        <Link to="/" className="flex items-center gap-1.5 sm:gap-2 text-foreground no-underline shrink-0 min-w-0">
          <div className="flex h-7 w-7 sm:h-8 sm:w-8 items-center justify-center rounded-lg bg-primary/15 shrink-0">
            <svg viewBox="0 0 24 24" className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-primary" fill="currentColor" aria-hidden>
              <path d="M4 4h6v6H4V4zm10 0h6v6h-6V4zM4 14h6v6H4v-6zm10 0h6v6h-6v-6z" />
            </svg>
          </div>
          <span className="font-semibold text-primary truncate">Stravo</span>
        </Link>

        {/* Middle: links (hash anchors for same-page sections) */}
        <div className="hidden items-center gap-1 md:flex min-w-0">
          {NAV_LINKS.map((item) => (
            <a
              key={item.label}
              href={item.href}
              className="flex items-center gap-0.5 rounded-md px-3 py-2 text-sm font-medium text-foreground/90 no-underline transition-colors hover:bg-muted/60 hover:text-foreground"
            >
              {item.label}
              {item.hasDropdown && <ChevronDown className="h-3.5 w-3.5 text-muted-foreground" aria-hidden />}
            </a>
          ))}
        </div>

        {/* Right: Login + Start free */}
        <div className="flex items-center gap-1 sm:gap-2 shrink-0">
          <Button variant="ghost" size="sm" className="h-8 px-2 sm:px-3 text-xs sm:text-sm" asChild>
            <Link to="/login">Login</Link>
          </Button>
          <Button size="sm" className="rounded-full h-8 px-3 text-xs sm:text-sm" asChild>
            <Link to="/login?mode=signup">Start free</Link>
          </Button>
        </div>
      </nav>
    </header>
  );
}
